import type {FileOverviewPayload} from '@github-ui/code-view-types'
import {useCurrentRepository} from '@github-ui/current-repository'
import {Box} from '@primer/react'
import {RecentlyTouchedBranches} from './RecentlyTouchedBranches'

export function OverviewHeader({payload}: {payload: FileOverviewPayload}) {
  const repo = useCurrentRepository()

  const {banners} = payload.overview

  return banners.recentlyTouchedDataChannel !== null ? (
    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      <RecentlyTouchedBranches channel={banners.recentlyTouchedDataChannel} repo={repo} />
    </Box>
  ) : null
}

try{ OverviewHeader.displayName ||= 'OverviewHeader' } catch {}